export default {"src":"/_next/static/media/uploading-loading-icon.0aa39dee.svg","height":125,"width":118,"blurWidth":0,"blurHeight":0};